import { Flex, TextField, Text, DialogRoot } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useFetch } from "../../../../../hooks/useFetch";
import { useAppStore } from "../../../../../stores/RootStore";
import { EquipmentModel } from "../../../../../types/types";
import { DialogClose, DialogContent, DialogDescription, DialogTitle } from "../../../../../ui/Dialog";
import { Label } from "../../../../../ui/Label/Label";
import { Input } from "../../../../../ui/Input/Input";
import { SelectButton } from "../../../../../ui/SelectButton/SelectButton";
import { Button } from "../../../../../ui/Button";
import DeleteModel from "./deleteModel";
import OneSelector from "../../../../../ui/OneSelector/OneSelector";

type Props = {
  id: string;
  producerId: string | undefined;
  isEditOpen: boolean;
  closeModal: Function;
  refreshModels: Function;
  equipmentModels: EquipmentModel[] | undefined;
};

const EditEquipment = ({ id, producerId, isEditOpen, closeModal, refreshModels, equipmentModels }: Props) => {
  const equipmentTypesData = useAppStore((state) => state.equipmentTypes);
  const equipmentTypes = equipmentTypesData?.map((type) => {
    return { value: type.id, label: type.attributes.name };
  })!;

  const currentModel = equipmentModels?.find((model) => model.id === id);

  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: currentModel?.attributes.name,
      equipment_type: {
        value: String(currentModel?.attributes.equipment_type_id),
        label: equipmentTypes.find((item) => item.value === String(currentModel?.attributes.equipment_type_id))?.label,
      },
    },
  });

  console.log(currentModel?.attributes.equipment_type_id);
  console.log(equipmentTypes.find((item) => item.value === String(currentModel?.attributes.equipment_type_id))?.label);

  const openStateChange = () => {
    if (isEditOpen) closeModal();
  };

  const [{ response: itemUpdateResponse, isLoading: itemUpdateIsLoading, error: itemUpdateError }, doFetchItemUpdate] =
    useFetch(`/directories/equipment_models/${id}`);

  const onSubmit = (formData: any) => {
    doFetchItemUpdate({
      method: "PUT",
      data: {
        data: {
          name: formData.name,
          equipment_type_id: formData.equipment_type.value,
          producer_id: producerId,
        },
      },
    });
    reset();
  };

  useEffect(() => {
    if (itemUpdateResponse) {
      refreshModels();
      openStateChange();
    }
  }, [itemUpdateResponse]);

  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  function onItemDelete(): void {
    openDeleteModal();
  }

  return (
    <DialogRoot open={isEditOpen} onOpenChange={openStateChange}>
      <DialogContent style={{ maxWidth: 600, position: "fixed", top: "30%" }}>
        <div className="text-lg font-medium">{t("editing_model")}</div>
        <div className="text-sm">{t("adding_model_form_text")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full items-end gap-4 mt-4">
            <div className="grid grid-cols-1 items-end w-full gap-4">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("title_name")}*</Label>
                    <Input {...field} />
                  </div>
                )}
              />
              <Controller
                name="equipment_type"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("equipment_type")}*</Label>
                    <OneSelector
                      placeholder={"Выберите тип оборудования"}
                      value={value ? equipmentTypes.find((s) => s.value == String(value.value))! : undefined}
                      onChange={onChange}
                      defaultOptions={equipmentTypes}
                    />
                    {/* <SelectButton
                      label={"Выберите тип оборудования"}
                      searchable={true}
                      options={equipmentTypes}
                      value={value ? equipmentTypes.find((s) => s.value == String(value.value))! : null}
                      onChange={onChange}
                    /> */}
                  </div>
                )}
              />
            </div>
            <div className="flex justify-between mt-4">
              <Button type="button" variant={"destructive"} size={"sm"} onClick={onItemDelete}>
                {t("delete")}
              </Button>
              <Button variant={"default"} size={"sm"}>
                {t("save")}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
      <DeleteModel
        id={id}
        isDeleteOpen={isDeleteOpen}
        closeModal={closeDeleteModal}
        refreshModels={refreshModels}
        closeModalOnDelete={closeModal}
      />
    </DialogRoot>
  );
};

export default EditEquipment;
